import { render, staticRenderFns } from "./DownloadAgreement.vue?vue&type=template&id=410f8d0c&"
import script from "./DownloadAgreement.js?vue&type=script&lang=js&"
export * from "./DownloadAgreement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports